import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import HorizontalLine from "Shared/HorizontalLine";
import { prefixClassUtil } from "src/utils";
import Item from "../Item";
import "./GroupItem.scss";

const PRE_NAME_CLASS = "UpgradesReview-GroupItem";
const prefixClass = prefixClassUtil(PRE_NAME_CLASS);

interface ItemData {
    id: number;
    img?: string | null;
    description?: string;
    price: number;
}

export interface Props {
    className?: string;
    title: string;
    items: ItemData[];

    onRemove?(id: number): void;
}

const GroupItem: FunctionComponent<Props & WithTranslation> = ({ className, title, items, onRemove, t }) => {
    function onItemRemove(id: number) {
        return () => onRemove && onRemove(id);
    }

    return (
        <div className={classNames(PRE_NAME_CLASS, className)}>
            <div className={prefixClass("main")}>
                <div className={prefixClass("title")}>{title}</div>

                <HorizontalLine />

                <div className={prefixClass("items")}>
                    {items && items.length ? (
                        items.map((m) => (
                            <Item
                                key={m.id}
                                className={prefixClass("item")}
                                img={m.img}
                                description={m.description}
                                price={m.price}
                                onRemove={onItemRemove(m.id)}
                            />
                        ))
                    ) : (
                        <p className={prefixClass("items--empty")}>
                            {t("ContinueDeal.UpgradesReview.GroupItem.noItems")}
                        </p>
                    )}
                </div>

                <HorizontalLine type={"dashed"} />
            </div>
        </div>
    );
};

export default withTranslation()(GroupItem);
